
const ControllingAddress = '0xA16cAaadD839B0Ad20C14E0f0059e4aC7A56F61E'

export default ControllingAddress
